import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

export const waitlistApiQueryKeys = {
  all: () => ['waitlist'] as const,
  byTour: (tourId: string) =>
    [TOUR_BASE_QUERY_KEY, tourId, 'waitlist'] as const,
  tourOptions: (tourId: string, participantBirthDate: string) =>
    [
      TOUR_BASE_QUERY_KEY,
      tourId,
      'form-tour-options',
      participantBirthDate,
    ] as const,
};
